const ensurePercentage = (progress: number): number => {
  return Math.max(Math.min(progress, 100), 0);
};

export default ensurePercentage;
